/* Ciondolini del configuratore Frasi — pulizia orfani (Marco 08/08).
   Le righe _bundle:frasi sono nascoste nel tema e il loro prezzo e' sommato
   alla riga della collana: se la collana viene rimossa, i ciondolini
   resterebbero in carrello invisibili ma pagati. Qui, a ogni aggiornamento
   del carrello, le righe bundle senza piu' la loro collana (_config_id
   orfano) vengono eliminate via cart/update.js. */
(function () {
  var inCorso = false;

  function radice() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function pulisci() {
    if (inCorso) return;
    fetch(radice() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var madri = {};
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          if (p._config_id && !p._bundle) madri[p._config_id] = true;
        });
        var orfani = cart.items.filter(function (it) {
          var p = it.properties || {};
          return p._bundle === 'frasi' && p._config_id && !madri[p._config_id];
        });
        if (!orfani.length) return;
        inCorso = true;
        var updates = {};
        orfani.forEach(function (it) { updates[it.key] = 0; });
        return fetch(radice() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          inCorso = false;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
      })
      .catch(function () { inCorso = false; });
  }

  var pulisciPiuTardi = function () { setTimeout(pulisci, 400); };

  /* Rimozione atomica (Marco 09/08): il "Rimuovi" della riga collana porta
     l'elenco delle chiavi del set (data-gg-remove-keys, messo dal Liquid su
     drawer e pagina carrello). Qui il click viene intercettato in capture —
     prima del componente del tema — e tutte le righe cadono in una chiamata
     sola, senza aspettare il giro del guardiano. */
  document.addEventListener('click', function (e) {
    var host = e.target && e.target.closest && e.target.closest('[data-gg-remove-keys]');
    if (!host) return;
    e.preventDefault();
    e.stopPropagation();
    var updates = {};
    (host.getAttribute('data-gg-remove-keys') || '').split(',').forEach(function (k) {
      if (k) updates[k] = 0;
    });
    if (!Object.keys(updates).length) return;
    fetch(radice() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () {
      if (window.location.pathname.indexOf('/cart') !== -1) {
        window.location.reload();
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      }
    });
  }, true);

  document.addEventListener('cart:refresh', pulisciPiuTardi);
  document.addEventListener('DOMContentLoaded', function () {
    // aggancio anche al bus del tema (rimozioni/quantita' dal drawer)
    if (window.FoxThemeEvents && window.FoxThemeEvents.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      try { FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, pulisciPiuTardi); } catch (e) { /* bus assente */ }
    }
    pulisci();
  });
})();
